/* pdp3-0210 / pdp4-0210 — "Completa il look": comportamento del selettore comune (snippet pdp-look-picker), usato dal
   pannello mobile (pdp-look-panel) e dalla sezione nella scheda (pdp-look-products). Un solo codice per entrambi.
   - Linguette dei look, taglie con lo stesso componente della scheda (radio + .studio-product__size).
   - "Aggiungi i selezionati": i capi del look con la taglia scelta (almeno uno) + il prodotto corrente.
   - "Aggiungi tutto il look": taglia obbligatoria su tutti i capi disponibili (evidenzia i mancanti) + il prodotto corrente.
   - Il prodotto corrente va nella variante scelta nella scheda (pdp4-0210: nessuna taglia preselezionata; la riga
     "Questo capo" del selettore è uno specchio dei selettori della scheda). Senza taglia si evidenzia la riga "Questo
     capo" e non si aggiunge nulla.
   - Aggiunta con la Cart API del tema (window.studio.addItemsToCart: /cart/add.js, più articoli, senza ricaricare) e
     apertura del cassetto carrello.
   - Pannello mobile: si apre dai pulsanti [data-look-open] (aria-controls = id del pannello), da sinistra, con focus
     dentro, Esc per chiudere. */
(function () {
  'use strict';
  if (window.studioLookPicker) return;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var COLOR = /^(colou?r|colore)$/i;

  function productSection(sid) { return document.getElementById('studio-product-' + sid); }
  function variantData(sid) {
    try { return JSON.parse(document.getElementById('studio-variant-data-' + sid).textContent); } catch (e) { return null; }
  }
  // gruppi di opzioni NON colore della scheda (taglie): servono a capire se c'è una scelta da fare e cosa evidenziare
  function mainVariant(sid) {
    var sec = productSection(sid), data = variantData(sid);
    var input = sec && sec.querySelector('[data-variant-id]');
    if (!data || !input) return null;
    for (var i = 0; i < data.variants.length; i++) if (String(data.variants[i].id) === String(input.value)) return data.variants[i];
    return null;
  }
  function mainLabel(sid, v) {
    var data = variantData(sid);
    var names = (data && data.optionNames) || [];
    return names.map(function (n, i) { return COLOR.test(n) ? null : n + ' ' + String(v.options[i] || '').split('(')[0].trim(); })
      .filter(Boolean).join(' · ');
  }
  // ------------------------------------------------------------------ pannello mobile
  var openers = {};
  function panelOf(picker) { return picker.closest('[data-look-panel]'); }
  function focusables(drawer) {
    return Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function onKey(e) {
    var panel = document.querySelector('[data-look-panel].is-open');
    if (!panel) return;
    if (e.key === 'Escape') { closePanel(panel, true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(panel.querySelector('.studio-look-panel__drawer'));
    if (!f.length) return;
    // in un gruppo di radio il Tab salta i non selezionati: si confronta con il primo e l'ultimo elemento raggiungibile
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  function openPanel(panel, btn) {
    openers[panel.id] = btn;
    if (panel.parentNode !== document.body) document.body.appendChild(panel); // fuori dai livelli della scheda
    panel.hidden = false;
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { panel.classList.add('is-open'); }); });
    document.documentElement.classList.add('studio-look-lock');
    document.addEventListener('keydown', onKey);
    var picker = panel.querySelector('[data-look-picker]');
    if (picker) refresh(picker);
    window.setTimeout(function () { var c = panel.querySelector('.studio-look-panel__close'); if (c) c.focus(); }, reduce ? 0 : 320);
  }
  function closePanel(panel, refocus) {
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('studio-look-lock');
    document.removeEventListener('keydown', onKey);
    window.setTimeout(function () { panel.hidden = true; }, reduce ? 0 : 320);
    var btn = openers[panel.id];
    if (refocus && btn) btn.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-look-open]');
    if (open) {
      var panel = document.getElementById(open.getAttribute('aria-controls'));
      if (panel) { e.preventDefault(); openPanel(panel, open); }
      return;
    }
    var close = e.target.closest && e.target.closest('[data-look-close]');
    if (close) { var p = close.closest('[data-look-panel]'); if (p) closePanel(p, true); }
  });

  // ------------------------------------------------------------------ selettore
  function say(picker, text) { var m = picker.querySelector('[data-look-msg]'); if (m) m.textContent = text || ''; }
  function activeLook(picker) { return picker.querySelector('[data-look]:not([hidden])'); }
  function itemValue(item) {
    var fixed = item.querySelector('[data-look-fixed]');
    if (fixed) return fixed.value;
    var r = item.querySelector('input[data-look-variant]:checked');
    return r ? r.value : '';
  }
  function setMissing(item, on) {
    item.classList.toggle('is-missing', on);
    var err = item.querySelector('[data-look-error]');
    if (err) err.hidden = !on;
  }
  function refresh(picker) {
    var sid = picker.dataset.section, cur = picker.querySelector('[data-look-current]');
    if (!cur) return;
    var v = mainVariant(sid);
    if (!v) cur.textContent = 'Insieme a questo capo: scegli la taglia.';
    else if (!v.available) cur.textContent = 'Questo capo, nella taglia scelta, è esaurito.';
    else { var l = mainLabel(sid, v); cur.textContent = 'Insieme a questo capo' + (l ? ' · ' + l : '') + '.'; }
  }

  async function add(picker, btn, all) {
    var sid = picker.dataset.section;
    say(picker, '');
    // home-0210: look singolo delle landing (data-look-standalone): nessun prodotto corrente, si aggiungono solo i capi del look
    var standalone = picker.hasAttribute('data-look-standalone');
    var main = standalone ? null : mainVariant(sid);
    if (!standalone && (!main || !main.available)) {
      // la riga "Questo capo" è uno specchio della scheda: si evidenzia lì, senza chiudere il pannello
      var row = picker.querySelector('[data-look-current-row]');
      var sec = productSection(sid);
      say(picker, main ? 'Questo capo è esaurito nella taglia scelta: scegline un\'altra.' : 'Scegli la taglia di questo capo.');
      if (!main && sec && typeof sec.studioRequireOptions === 'function') sec.studioRequireOptions(row, true);
      return;
    }
    var items = Array.prototype.slice.call(activeLook(picker).querySelectorAll('[data-look-item]:not([data-look-soldout])'));
    var picked = [], missing = [];
    items.forEach(function (it) {
      var v = itemValue(it);
      if (v) picked.push({ id: Number(v), quantity: 1 }); else missing.push(it);
      setMissing(it, all && !v);
    });
    if (all && missing.length) {
      say(picker, missing.length === 1 ? 'Scegli la taglia del capo evidenziato.' : 'Scegli la taglia dei capi evidenziati.');
      var first = missing[0].querySelector('input[data-look-variant]:not([disabled])');
      missing[0].scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      if (first) first.focus({ preventScroll: true });
      return;
    }
    if (!picked.length) { say(picker, 'Scegli la taglia di almeno un capo del look.'); return; }
    if (!window.studio || typeof window.studio.addItemsToCart !== 'function') return;
    await window.studio.addItemsToCart((standalone ? [] : [{ id: Number(main.id), quantity: 1 }]).concat(picked), btn);
    if (document.querySelector('.studio-cart-drawer--open')) {
      var pnl = panelOf(picker);
      if (pnl) closePanel(pnl, false);
      picker.querySelectorAll('input[data-look-variant]:checked').forEach(function (r) { r.checked = false; });
      say(picker, '');
    }
  }

  function init(picker) {
    if (!picker || picker.dataset.bound) return;
    picker.dataset.bound = '1';
    picker.querySelectorAll('[data-look-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        picker.querySelectorAll('[data-look-tab]').forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
        picker.querySelectorAll('[data-look]').forEach(function (p) { p.hidden = p.dataset.look !== tab.dataset.lookTab; });
        say(picker, '');
      });
    });
    picker.addEventListener('change', function (e) {
      var it = e.target.closest && e.target.closest('[data-look-item]');
      if (it && e.target.matches('input[data-look-variant]')) setMissing(it, false);
    });
    picker.querySelector('[data-look-add-selected]').addEventListener('click', function (e) { add(picker, e.currentTarget, false); });
    picker.querySelector('[data-look-add-all]').addEventListener('click', function (e) { add(picker, e.currentTarget, true); });
    // la taglia della scheda può cambiare anche dalla barra fissa o da un link: il testo in fondo si aggiorna
    var sec = productSection(picker.dataset.section);
    if (sec) sec.addEventListener('change', function () { window.setTimeout(function () { refresh(picker); }, 0); });
    refresh(picker);
  }

  window.studioLookPicker = { init: init };
  function boot() { document.querySelectorAll('[data-look-picker]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
